export const geolocationMessage=(error:unknown)=>{
  const code=typeof error==="object"&&error!==null&&"code" in error?Number((error as {code?:number}).code):0;
  if(code===1)return "Sijaintilupa on estetty. Salli sijainti selaimen osoiterivin asetuksista tai jatka nimihaulla.";
  if(code===2)return "Laite ei pystynyt määrittämään sijaintia. Tarkista, että laitteen sijaintipalvelu on päällä, ja yritä uudelleen.";
  if(code===3)return "Sijainnin määrittäminen kesti liian kauan. Siirry tarvittaessa lähemmäs ikkunaa tai jatka nimihaulla.";
  return error instanceof Error?error.message:"Sijaintia ei saatu juuri nyt.";
};

const currentPosition=(options:PositionOptions)=>new Promise<GeolocationPosition>((resolve,reject)=>navigator.geolocation.getCurrentPosition(resolve,reject,options));

export async function getTransientPosition(onRetry?:()=>void){
  if(!window.isSecureContext)throw new Error("Sijaintia voi käyttää vain suojatulla HTTPS-yhteydellä.");
  if(!navigator.geolocation)throw new Error("Selain ei tue sijainnin käyttöä.");
  try{return await currentPosition({enableHighAccuracy:false,timeout:12000,maximumAge:900000});}
  catch(firstError){
    const code=typeof firstError==="object"&&firstError!==null&&"code" in firstError?Number((firstError as {code?:number}).code):0;
    if(code===1)throw firstError;
    onRetry?.();
    return currentPosition({enableHighAccuracy:true,timeout:20000,maximumAge:0});
  }
}
